
<template>
  <div class="uk-margin-bottom uk-grid">
    <div class="uk-width-1-1 uk-width-medium-1-3 uk-grid-margin">
      <SelectRow
        v-model="form.salutation"
        name="salutation"
        :label="$t('events.entry_salutation_label')"
        :error-message="formError('salutation', 'required')"
        :disabled="disabled"
        :options="saluations"
        @input="emitFormInput"
      />
    </div>
    <div class="uk-width-1-1 uk-width-medium-1-3 uk-grid-margin">
      <input-row
        v-model="$v.form.first_name.$model"
        name="first_name"
        :disabled="disabled"
        :label="$t('events.entry_first_name_label')"
        :error-message="formError('first_name', 'required')"
        @input="emitFormInput"
      />
    </div>
    <div class="uk-width-1-1 uk-width-medium-1-3 uk-grid-margin">
      <input-row
        v-model="$v.form.last_name.$model"
        name="last_name"
        :disabled="disabled"
        :label="$t('events.entry_last_name_label')"
        :error-message="formError('last_name', 'required')"
        @input="emitFormInput"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Mixins, Watch } from "vue-property-decorator";
import form from "../form/form-wrapper.vue";
import formRow from "../form/form-row.vue";
import input from "../form/input-row.vue";
import formError from "../form/form-error.vue";
import datePicker from "../form/date-picker.vue";
import SelectRow from "../form/select-row.vue";
import { ModelErrors } from "../../models/Model";
import { validationMixin } from "vuelidate";
import { required } from 'vuelidate/lib/validators';
import FormStep from "./FormStep";
import UserModel from "../../models/UserModel";


@Component({
  components: {
    'form-wrapper': form,
    'form-row': formRow,
    'input-row': input,
    'form-error': formError,
    'date-picker': datePicker,
    SelectRow,
  },
  mixins: [validationMixin],
  validations: {
    form: {
      salutation: {
        required,
      },
      first_name: {
        required
      },
      last_name: {
        required
      }
    }
  }
})
export default class GuardianDetailsStep extends FormStep {
  @Prop() readonly value!: GuardianDetails;
  @Prop({default: () => { return {}}}) errors!: ModelErrors;

  form: GuardianDetails = {
    salutation: '',
    first_name: '',
    last_name: '',
  }

  user!: UserModel;

  mounted(): void {
    if (!this.form.first_name) {
      this.form.first_name = this.user.data.first_name;
    }
    if (!this.form.last_name) {
      this.form.last_name = this.user.data.last_name;
    }
  }

  data(): any {
    return {
      form: JSON.parse(JSON.stringify(this.value)),
    }
  }

  get saluations(): SelectOption[] {
    let options = this.$store.getters['modules/getModuleContext']('events-submissions').salutations.map((a: string) => {
      return {label: a, value: a};
    });

    return options;
  }

  @Watch('value', {immediate: true, deep: true})
  valuePropUpdated(v: StudentDetails): void {
    this.form = JSON.parse(JSON.stringify(v));
  }

  emitFormInput(): void {
    this.$emit('input', this.form);
  }
}
</script>

<style scoped>

</style>
